// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect } from 'react'; // eslint-disable-line no-unused-vars
import { createBrowserHistory } from 'history';
import useHistoryState from 'pubweb-smokey/dist/hooks/useHistoryState';
import { debounceEvent } from 'pubweb-smokey/dist/utils/utils';

// why this? because we don't actually want updates to force a refresh
// plus, in order to prevent scrolling during a scroll freeze, we need the update to be immediate
// and setState doesn't apply to state until the next refresh
let scrollState = {};
let scrollPreventionCount = 0;
const SCROLL_PREVENTION_WARNING_THRESHOLD = 5;

export const freezeScrollForUpdate = () => {
  scrollState = {
    x: window.scrollX,
    y: window.scrollY,
    frozen: true,
    releaseAfterUpdate: true,
  };

  scrollPreventionCount = 0;

  window.addEventListener('scroll', preventScroll);
};

export const freezeScroll = () => {
  scrollState = {
    x: window.scrollX,
    y: window.scrollY,
    frozen: true,
    releaseAfterUpdate: false,
  };

  scrollPreventionCount = 0;
  window.addEventListener('scroll', preventScroll);
};

export const releaseScroll = () => {
  scrollState = {
    x: window.scrollX,
    y: window.scrollY,
    frozen: false,
    releaseAfterUpdate: false,
  };

  window.removeEventListener('scroll', preventScroll);
};

const preventScroll = (e) => {
  if (scrollState.frozen) {
    scrollPreventionCount++;

    e.preventDefault();

    if (scrollPreventionCount >= SCROLL_PREVENTION_WARNING_THRESHOLD) {
      console.error(
        'Scroll prevention has occurred ' +
          scrollPreventionCount +
          ' times. When using freezeScroll, be sure to use releaseScroll so the user can continue to navigate.'
      );
    }

    window.scrollTo(scrollState.x, scrollState.y);

    if (scrollState.releaseAfterUpdate) {
      scrollState = {};
      window.removeEventListener('scroll', preventScroll);
    }
  } else {
    // safe guard in case this isn't released properly
    window.removeEventListener('scroll', preventScroll);
  }
};

const ScrollContext = ({ children }) => {
  const [scroll, setScroll] = useHistoryState({ x: 0, y: 0 }, 'scroll');

  const captureScrollState = debounceEvent(() => {
    setScroll({ x: window.scrollX, y: window.scrollY });
  }, 250);

  useEffect(() => {
    const history = createBrowserHistory();

    // browser navigation
    window.history.scrollRestoration = 'manual';

    window.removeEventListener('scroll', captureScrollState);

    if (history.action === 'POP') {
      window.scrollTo(scroll.x, scroll.y);
    } else {
      window.scrollTo(0, 0);
    }

    window.addEventListener('scroll', captureScrollState);

    return () => {
      window.removeEventListener('scroll', preventScroll);
      window.removeEventListener('scroll', captureScrollState);
    };
  }, []);

  return children;
};

export default ScrollContext;
